// extracted by mini-css-extract-plugin
export default {"button":"Insert_button__2oSRZ"};